import type { ComponentProps, FC, ReactNode } from 'react'

import Link from 'next/link'

type TransitionLinkProps = ComponentProps<typeof Link>

export const TransitionLink: FC<TransitionLinkProps> = ({ scroll = false, ...props }): ReactNode => {
    return <Link scroll={scroll} {...props} />
}
